const ngDevMode = typeof ngDevMode === 'undefined' ? true : ngDevMode;
export { ngDevMode };
